import React from 'react';

export default function Header({ showBack = false, onBack }) {
  return (
    <header className="header">
      {/* Red Bar */}
      <div className="header-bar">
        <div className="header-bar-inner">
          {/* Left Action */}
          {showBack && (
            <button
              className="back-btn"
              onClick={onBack}
            >
              <i className="fa-solid fa-arrow-left header-back-icon"></i>Back
            </button>
          )}

          <a href="https://opticonframing.com.au/order-frames-and-canvas/print-plus-frames/" className="header-store-link">
            STORE HOME PAGE
          </a>
        </div>
      </div>

      {/* Logo Container (overlapping bar on RIGHT) */}
      <div className="header-logo-wrap">
        <a href="https://opticonframing.com.au/order-frames-and-canvas/print-plus-frames/" className="header-logo">
          <img src="/favicon.ico" alt="Opticon Logo" />
        </a>
      </div>
    </header>
  );
}
